// frontend/src/config/defaultSiteConfig.js

export const DEFAULT_SITE_CONFIG = {
  meta: {
    allowedKinds: ["digital", "other"],
  },
  content: {
    hero: {
      headline: "578 Productions",
      tagline: "A curious little studio that makes interesting things.",
      subline: "Digital products, templates, games, and media for people who think sideways and kittywampus.",
    },
    intro: {
      text: "578 is the creative studio of 1521 Holdings. We design things, name things, and occasionally build things that make people laugh or get their work done — sometimes both at once.",
      productsSectionIntro: "Every piece is different. The frame holds it together.",
      shopCtaLabel: "",
      shopCtaUrl: "",
    },
    footer: {
      closingTagline: "578 is a mosaic. Every piece is different. Same frame.",
      companyName: "578 Productions",
      copyrightText: "A weird little studio that makes interesting things.",
      signupButtonLabel: "Sign Up for Updates",
      signupButtonUrl: "mailto:hello@578productions.com",
      shopButtonLabel: "Browse the Shop",
      shopButtonUrl: "#",
    },
  },
  colors: {
    primary: "#E8A33A",
    secondary: "#2B7D6E",
    accentOrange: "#D66B28",
    accentTerracotta: "#E05A2D",
    accentSky: "#4DA8C4",
    leadline: "#1E1E1E",
    backgroundClear: "#F5EDE0",
    backgroundFrosted: "#F9F5EE",
    textDark: "#3A3530",
  },
  typography: {
    headingFont: "Federo",
    bodyFont: "Outfit",
  },
  sections: {
    hero: {
      backgroundColor: "backgroundClear",
      showBorder: true,
      showCornerAccents: true,
    },
    intro: {
      visible: true,
      backgroundColor: "backgroundClear",
    },
    products: {
      showDividers: true,
      showMosaicBar: false,
    },
    footer: {
      backgroundColor: "leadline",
      textColor: "backgroundClear",
      showMosaicBar: true,
    },
  },
  partners: [
    {
      id: "bahar-labs",
      name: "Bahar Labs",
      linkText: "baharlabs.com",
      url: "https://baharlabs.com",
      description: "The tech behind our products is built with Bahar Labs — thoughtful tech for everyday life.",
      accent: "teal",
    },
    {
      id: "misfit-floofs",
      name: "Misfit Floofs Collective",
      linkText: "misfitfloofs.com",
      url: "https://misfitfloofs.com",
      description: "Our rescue and animal welfare work happens through Misfit Floofs Collective — because some of us spend our free time keeping neonatal kittens alive at 2am.",
      accent: "amber",
    },
  ],
  productGroups: [
    { id: "templates", title: "Templates & Tools", intro: "", colorKey: "primary", textOnDark: false, order: 0 },
    { id: "games", title: "Goofy Games", intro: "To pass the time and amuse your friends", colorKey: "secondary", textOnDark: true, order: 1 },
    { id: "media", title: "Content & Media", intro: "", colorKey: "accentSky", textOnDark: false, order: 2 },
  ],
  products: [
    { id: "template-seizemypage", group: "templates", order: 1, name: "SeizeMyPage", description: "Drag-and-drop PDF layout templates. Professional pages without touching design software. Download, customize, done.", accent: "amber", buttonLabel: "", buttonUrl: "", kind: "digital", format: "template", storeId: "", checkoutUrl: "" },
    { id: "template-compliance-hub", group: "templates", order: 2, name: "Compliance Hub for Notion", description: "Everything a solo compliance practitioner needs in one workspace. Frameworks, trackers, policy templates, audit prep. Stop rebuilding the wheel every engagement.", accent: "teal", buttonLabel: "", buttonUrl: "", kind: "digital", format: "template", storeId: "", checkoutUrl: "" },
    { id: "template-product-design-hub", group: "templates", order: 3, name: "Product Design Hub for Notion", description: "Structured workspace for taking products from idea to shipped. Briefs, roadmaps, decision logs, launch checklists.", accent: "orange", buttonLabel: "", buttonUrl: "", kind: "digital", format: "template", storeId: "", checkoutUrl: "" },
    { id: "template-scoopsuite", group: "templates", order: 4, name: "ScoopSuite", description: "Energy management toolkit for brains that don't do \"just make a to-do list.\" Track your capacity in scoops, not hours. Plan around your energy, not against it. Built for ADHD, useful for everyone.", accent: "terracotta", buttonLabel: "", buttonUrl: "", kind: "digital", format: "template", storeId: "", checkoutUrl: "" },
    { id: "template-prompt-packs", group: "templates", order: 5, name: "Prompt Packs", description: "Curated, tested, actually useful prompts for people who work with AI daily. Not 500 generic prompts in a PDF. The ones that produce results.", accent: "sky", buttonLabel: "", buttonUrl: "", kind: "digital", format: "template", storeId: "", checkoutUrl: "" },
    { id: "game-rapture-roulette", group: "games", order: 1, name: "Rapture Roulette", description: "Spin the wheel, get an apocalyptic sign, collect them on your bingo card, claim prophet credit when they come true. Share the meme. Blame the end times.", accent: "terracotta", buttonLabel: "", buttonUrl: "", kind: "other", format: "game", storeId: "", checkoutUrl: "" },
    { id: "media-fries-only", group: "media", order: 1, name: "Fries Only", description: "Video essays that take apart persuasion, marketing psychology, and the ethics of selling things to people.", accent: "amber", buttonLabel: "", buttonUrl: "", kind: "other", format: "media", storeId: "", checkoutUrl: "" },
    { id: "media-gifted-tokens", group: "media", order: 2, name: "Gifted Tokens", description: "Newsletter for late-diagnosed, neurodivergent professionals building with AI. Light on top, deep underneath.", accent: "sky", buttonLabel: "", buttonUrl: "", kind: "other", format: "media", storeId: "", checkoutUrl: "" },
  ],
};

export const SITE_SLUG = "578-prod";
